export const isFullscreen = (document: Document) => {
  if (document.webkitFullscreenElement) {
    return !!document.webkitFullscreenElement;
  } else if (undefined == document.fullscreenElement) {
    // safari sets this as undefined...
    return false;
  } else {
    return !!document.fullscreenElement;
  }
};
